import StandProductsTable from "./stand-downloads-table";

export default StandProductsTable;
